import Button from '@williamhill/rosi-ui-shared/src/components/button';
import { withRootTestId } from '@williamhill/rosi-ui-shared/src/lib';
import React, { ReactNode, useCallback } from 'react';
import styled from 'styled-components';
import { Block } from '@williamhill/rosi-ui-shared/src/components/typography';

export default function Modal({ children }: { children: ReactNode }) {
  return <ModalContainer>{children}</ModalContainer>;
}

export interface SubmissionModalProps {
  title: string;
  submitTitle: string;
  onSubmit: () => void;
  cancelTitle?: string;
  onCancel: () => void;
  baseTestId?: string;
}

export function SubmissionModalContent({
  title,
  submitTitle,
  onSubmit,
  cancelTitle = 'Close',
  onCancel,
  baseTestId
}: SubmissionModalProps) {
  const withId = useCallback(withRootTestId(baseTestId ? `${baseTestId}-submission-modal` : 'submission-modal'), [
    baseTestId
  ]);
  return (
    <SubmissionModalContainer>
      <Block weight="black" data-testid={withId('title')}>
        {title}
      </Block>
      <Button dataTestId={withId('submit')} modifiers="secondaryRound" buttonSize="fit" onClick={onSubmit}>
        {submitTitle}
      </Button>
      <CancelButton dataTestId={withId('cancel')} modifiers="headerTab" onClick={onCancel}>
        {cancelTitle}
      </CancelButton>
    </SubmissionModalContainer>
  );
}

const ModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  background: ${({ theme }) => `${theme.colors.black}19`};
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;

const SubmissionModalContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 3.2rem;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  padding: 3.2rem 9.7rem;

  align-self: flex-start;
  margin-top: 46%;
`;

const CancelButton = styled(Button)`
  padding: 0;
`;
